import React, { useRef } from 'react';
import EmailEditor from 'react-email-editor';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';

const EmailBuilder = () => {
  const emailEditorRef = useRef(null);
  const [saving, setSaving] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const location = useLocation();
  const [type, setType] = React.useState(location.state?.id);

  const deleteTemplate = () => {
    axios.post(process.env.REACT_APP_API_URL + 'email/templates', {
        action: 'DELETE',
        type
    })
  }

  // 1. Export and Save to Database
  const saveTemplate = () => {
    if (saving)
        return;
    setSaving(true);

    const unlayer = emailEditorRef.current.editor;

    unlayer.exportHtml((data) => {
      const { design, html } = data;
      
        axios.post(process.env.REACT_APP_API_URL + 'email/templates', {
            action: 'UPSERT',
            type,
            json: design,
            html
        }).then(r => {
            if (r?.data?.status === 'Success') {
                toast.success('Template saved.');
                return;
            }
            toast.error('Template failed to save.');
        });
      
    });
  };

  // 2. Setup Variables and File Uploads
  const onReady = (unlayer) => {
    // Define the variables your client can click and insert
    var mergeTags = [
        { name: 'URL', value: '{{site_url}}', sample: 'https://premium-podcast.westus2.cloudapp.azure.com/' },
        { name: 'UTC Date', value: '{{current_date}}', sample: '9/22/2026' },
        { name: 'UTC Date (Long)', value: '{{current_date_long}}', sample: 'September 22, 2026' },
        { name: 'UTC Time', value: '{{current_time}}', sample: '4:30 PM' }
    ];
    switch (type) {
        case 'claim_podcast':
            mergeTags.push({ name: 'Podcast Name', value: '{{podcast_name}}', sample: 'The Joe Rogan Experience' });
            mergeTags.push({ name: 'Code', value: '{{code}}', sample: '3c4fcfe6-44c8-11f1-8eb8-000d3a6f331b' });
            mergeTags.push({ name: 'Verify Link', value: '{{verify_url}}', sample: 'https://premium-podcast.westus2.cloudapp.azure.com/podcast/verification/3c4fcfe6-44c8-11f1-8eb8-000d3a6f331b' });
            break;
        case 'forgot_password':
            mergeTags.push({ name: 'First Name', value: '{{first_name}}', sample: 'John' });
            mergeTags.push({ name: 'Last Name', value: '{{last_name}}', sample: 'Smith' });
            mergeTags.push({ name: 'Email', value: '{{email}}', sample: 'john.smith@email.com' });
            mergeTags.push({ name: 'Reset Link', value: '{{reset_url}}', sample: 'https://premium-podcast.westus2.cloudapp.azure.com/password/reset/3c4fcfe6-44c8-11f1-8eb8-000d3a6f331b' });
            break;
        case 'host_guest_join':
        case 'podcast_join':
            mergeTags.push({ name: 'First Name', value: '{{first_name}}', sample: 'John' });
            mergeTags.push({ name: 'Last Name', value: '{{last_name}}', sample: 'Smith' });
            mergeTags.push({ name: 'Email', value: '{{email}}', sample: 'john.smith@email.com' });
            break;
    }
    unlayer.setMergeTags(mergeTags);

    // Handle Image Uploads
    unlayer.registerCallback('image', (file, done) => {
      const formData = new FormData();
      formData.append('file', file.stack[0]);

      // Change this URL to your actual upload endpoint
      axios.post(`${process.env.REACT_APP_API_URL}file/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then((r) => {
            if (r?.data?.status === 'Success') {
                done({ url: process.env.REACT_APP_MEDIA_URL + r.data.url });
            }
        })
        .catch((err) => console.error('Upload failed:', err));
    });

    axios.post(`${process.env.REACT_APP_API_URL}email/templates`, {
        action: 'SELECT',
        type
    })
        .then(r => {
            if (r?.data?.status === 'Success') {
                const design = typeof r.data.results[0].designJson === 'string' 
                    ? JSON.parse(r.data.results[0].designJson) 
                    : r.data.results[0].designJson ;
                
                unlayer.loadDesign(design);
            }
            setLoading(false);
        })
        .catch(err => {
            console.error("Failed to load template", err);
            setLoading(false);
        });
  };

  return (
    <div style={{ height: 'calc(100vh - 80px)', display: 'flex', flexDirection: 'column' }}>
      <nav style={{ padding: '15px', color: '#222', display: 'flex', justifyContent: 'space-between' }}>
        <h2 style={{ margin: 0 }}>Template Editor</h2>
        <div style={{display: 'flex', gap: 15}}>
            <a href="/template-list" className="btn btn-orange" style={{ padding: '8px 16px', cursor: 'pointer' }}>
                Cancel
            </a>
            <button onClick={deleteTemplate} className="btn btn-red" style={{ padding: '8px 16px', cursor: 'pointer' }}>
                Delete
            </button>
            <button onClick={saveTemplate} className="btn" style={{ padding: '8px 16px', cursor: 'pointer' }}>
                Save
            </button>
        </div>
      </nav>

      <EmailEditor 
        ref={emailEditorRef} 
        onReady={onReady} 
      />
    </div>
  );
};

export default EmailBuilder;